export function formatDate(date: Date | undefined | null, options: Intl.DateTimeFormatOptions = {}): string {
  if (!date) {
    return '';
  }

  const formattedDate = date.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options,
  });

  return formattedDate;
}

export function formatDateToLocal(date: Date | undefined | null): string {
  if (!date) {
    return '';
  }

  const formattedDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    month: 'short',
    year: 'numeric',
    day: 'numeric',
  }).format(date);

  return formattedDate;
}

export function formatNonTimezoneDate(dateStr: Date | undefined | null): string {
  if (!dateStr) {
    return '';
  }
  const formattedDate = Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(dateStr));

  return formattedDate;
}

/**
 * Formats a date to display month and year only (e.g. "February 2026").
 * Handles full ISO datetime strings, YYYY-MM-DD, and YYYY-MM strings.
 */
export function formatMonthYear(dateStr: string | Date | undefined | null): string {
  if (!dateStr) return '';
  const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  if (isNaN(date.getTime())) return '';

  return Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(date);
}

/**
 * Formats a date for DatePicker input value, avoiding timezone boundary issues.
 * Converts dates to ISO 8601 format at noon UTC to ensure the correct calendar date
 * is displayed across all timezones.
 *
 * @param dateValue - Date string or Date object (typically from API response)
 * @returns ISO 8601 string at noon UTC, or empty string for invalid dates
 *
 * @example
 * // Input from API: '1964-10-01T00:00:00.000Z'
 * // Output: '1964-10-01T12:00:00.000Z'
 * // Result: DatePicker displays '1964-10-01' for all users (PST, EST, UTC, etc.)
 */
export function formatDateToPopulateDatePicker(dateValue: string | Date): string {
  if (!dateValue) return '';
  const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
  if (isNaN(date.getTime())) return '';

  // Extract UTC date components
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  // Return ISO string at noon UTC to avoid timezone boundary issues
  // This ensures users in any timezone see the correct calendar date
  return `${year}-${month}-${day}T12:00:00.000Z`;
}
